import Tabs from './tabs.vue';
import Tab from './tab.vue';

const install = (Vue) => {
  Vue.component('tabs', Tabs);
  Vue.component('tab', Tab);
};

export default {
  install,
};

export { Tabs, Tab };
